import { LucideIcon, FileText } from 'lucide-react';
import {
  CampaignIcon,
  SurveyIcon,
  PollIcon,
  OutreachMessageIcon,
  PetitionIcon,
} from '../icons';

/**
 * The outreach type → glyph map. Four surfaces carried identical private
 * switch statements for this; they now share one. FileText is the unknown-
 * type fallback.
 */
const OUTREACH_TYPE_ICONS: Record<string, LucideIcon> = {
  campaign: CampaignIcon,
  survey: SurveyIcon,
  poll: PollIcon,
  message: OutreachMessageIcon,
  petition: PetitionIcon,
};

export function outreachTypeIcon(type: string): LucideIcon {
  return OUTREACH_TYPE_ICONS[type] ?? FileText;
}
